/**
 * Order intake validation pipeline error `code` values (spec Part 14).
 * Responses must use these literals for machine-readable clients.
 */
export const ORDER_VALIDATION_CODES = {
    JURISDICTION_NOT_PERMITTED: "JURISDICTION_NOT_PERMITTED",
    PURCHASE_LIMIT_EXCEEDED: "PURCHASE_LIMIT_EXCEEDED",
    INSUFFICIENT_INVENTORY: "INSUFFICIENT_INVENTORY",
    /** Line item quantity is zero, negative, or not a positive finite number (DEV-022). */
    INVALID_LINE_QUANTITY: "INVALID_LINE_QUANTITY",
    /**
     * Delivery address fails Colorado MED private-residence delivery checks (Rule 3-615(B));
     * see **`reason`** (MED 1 CCR 212-3).
     */
    DELIVERY_ADDRESS_NOT_ELIGIBLE: "DELIVERY_ADDRESS_NOT_ELIGIBLE",
    /**
     * **`subtotalCents` + `taxCents` + `customerDeliveryFeeCents` + `coSurchargeCents`** must equal **`receivedTotalCents`**,
     * and **`customerDeliveryFeeCents`** must match the server-resolved schedule at order time (**ADR-104**).
     */
    ORDER_TOTAL_MISMATCH: "ORDER_TOTAL_MISMATCH",
    /**
     * **COMP-200** — the government ID on file for the customer is expired, or has
     * no expiration on file at all. Intake fails closed on both; see **`reason`**.
     */
    ID_DOCUMENT_NOT_VALID: "ID_DOCUMENT_NOT_VALID",
};
/**
 * **`expired`** — expiry on file has passed. **`expiry_unknown`** — nothing usable
 * on file (never verified, verified before the field was captured, or the vendor
 * returned no expiration for the document type). Both block order intake; only
 * **`expired`** blocks at the door (COMP-200).
 */
export const ID_DOCUMENT_NOT_VALID_REASONS = ["expired", "expiry_unknown"];
//# sourceMappingURL=order-validation.js.map